import { useCallback } from "react";
import { useActorEmail } from "./useActorEmail";
import { readOperatorToken } from "./useOperatorToken";
import type { OperatorIdentity } from "../api/operatorHeaders";

/**
 * Returns a function that reads the signed-in operator at call time: the
 * FusionAuth e-mail and, when readable, the id token cookie (no refresh).
 * The token is handed straight to one request; it is never put in state,
 * the React Query cache or a log (abo-data-access-guard task 05).
 */
export const useOperatorIdentity = (): (() => OperatorIdentity) => {
  const email = useActorEmail();
  return useCallback(
    () => ({ email, token: readOperatorToken() }),
    [email]
  );
};
